// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1RN9y","colMin":"styles_colMin__6deVV","colCheckbox":"styles_colCheckbox__1xR11"};